import { Component, Input } from '@angular/core';

import { Observable, of } from 'rxjs';

@Component({
    selector: 'aa-warning-badge',
    templateUrl: './warning-badge.component.html',
    styleUrls: [
        './warning-badge.component.scss'
    ],
    standalone: false
})
export class WarningBadgeComponent
{
    @Input() warningBadgeValue: Observable<number> = of(0);
}
